import { __read } from "tslib";
import React, { useEffect } from 'react';
import { Dialog, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { CloseIcon } from '../../icons/draft';
import { ModalHeaderAction, ModalHeader, ModalContent, ModalTitle, ModalSubtitle, ModalBody, useDialogStyles, } from './Modal.styled';
export var Modal = function (_a) {
    var children = _a.children, isOpened = _a.isOpened, onClose = _a.onClose, className = _a.className;
    var theme = useTheme();
    var _b = __read(React.useState(typeof isOpened === 'boolean' ? isOpened : true), 2), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        if (typeof isOpened === 'boolean') {
            setOpen(isOpened);
        }
    }, [isOpened]);
    var handleClose = function () {
        if (typeof isOpened !== 'boolean') {
            setOpen(false);
        }
        onClose && onClose();
    };
    var styles = useDialogStyles();
    return (React.createElement(Dialog, { fullWidth: true, "aria-labelledby": "modal-title", open: open, classes: { paper: clsx(styles.root, className) }, onBackdropClick: handleClose, onKeyDown: function (evt) { return evt.keyCode === 27 && handleClose(); } },
        React.createElement(ModalHeader, { id: "modal-title" },
            React.createElement(ModalHeaderAction, { onClick: handleClose },
                React.createElement(CloseIcon, { size: "s", color: theme.palette.primary.dark }))),
        React.createElement(ModalContent, null, children)));
};
Modal.Title = ModalTitle;
Modal.Subtitle = ModalSubtitle;
Modal.Body = ModalBody;
//# sourceMappingURL=Modal.js.map